import { FormBlock, FormCard } from '@qbe/ads-blocks-forms';
import { Button, Spinner, Typography } from '@qbe/ads-core';
import React, { useEffect } from 'react';

import { useAppContent, useAppDispatch, useCoverDetailsEffects } from '~/hooks';
import { addValidatedCover } from '~/slices/selectCover';
import { qalFormCompleteAction, qalFormStartAction } from '~/thunks/analytics';
import { Cover } from '~/types/cover';
import { isFormStartStarted } from '~/utils/analytics/trackUtils';

const CoverDetailsGlass: React.FC = () => {
  const dispatch = useAppDispatch();
  const { quotePremiums, isLoading, buttonText } = useCoverDetailsEffects({
    cover: Cover.Glass,
  });

  const handleFormStart = () => {
    if (!isFormStartStarted()) dispatch(qalFormStartAction());
  };
  const handleFormComplete = () => {
    if (isFormStartStarted()) dispatch(qalFormCompleteAction());
  };

  useEffect(() => {
    dispatch(addValidatedCover(Cover.Glass));
  }, [dispatch]);

  const handleNext = async (e: React.MouseEvent<HTMLElement>) => {
    handleFormStart();
    handleFormComplete();
    e.preventDefault();
    await quotePremiums();
  };

  const { getTextContent: getSharedContent } = useAppContent({
    basePath: 'shared',
  });

  const { getTextContent } = useAppContent({ basePath: 'dsme.coverDetailsGlass' });

  return (
    <FormCard
      variant="sectionTitle"
      title={getTextContent('title')}
      data-testid="cover-details-glass"
    >
      <Spinner description={getSharedContent('loadingLabel')} loading={isLoading} />

      <FormBlock preset="text_questionDesc">
        <Typography textAlign="center">{getTextContent('description')}</Typography>
      </FormBlock>
      <FormBlock preset="button">
        <Button
          variant="primary-on-light"
          label={buttonText}
          type="submit"
          onClick={handleNext}
          disabled={isLoading}
          data-track={`${buttonText} - glass`}
        />
      </FormBlock>
    </FormCard>
  );
};

export default CoverDetailsGlass;
